<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogFormVisible"
    center
    :close-on-click-modal="false" :append-to-body="true"
    custom-class="max-dialog1256"
  >
    <el-form :model="form">
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item label="优惠券数量" :label-width="formLabelWidth" prop="count">
            <el-input-number v-model="form.count" @change="handleChange" :min="1"></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="已使用金额" :label-width="formLabelWidth" prop="hasuse" v-if="title!='加急券'&&title!='销售套餐'">
            <el-input-number v-model="form.hasuse"></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24" v-if="title=='加工券'||title=='现金抵扣券'">
        <el-col :span="24">
          <el-form-item label="有效日期" :label-width="formLabelWidth">
            <el-date-picker style="width:260px;"
                            v-model="searchdatevalue"
                            type="daterange" :value-format="'yyyy-MM-dd'"
                            align="left" :unlink-panels="false"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="选择客户" :label-width="formLabelWidth" prop="couponnum">
            <AutoCustomer @clear="clearCustomerName" :content="form.customername" :size="''"
                          @handleSelect="selectExternalDept"></AutoCustomer>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24" v-if="title=='加工券'||title=='现金抵扣券'||title=='销售套餐'">
        <el-col :span="12">
          <el-form-item label="购买方式" :label-width="formLabelWidth" prop="paytype">
            <el-radio v-model="form.paytype" label="s">赠送</el-radio>
            <el-radio v-model="form.paytype" label="z">转账</el-radio>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="备注" :label-width="formLabelWidth" prop="remark">
            <el-input v-model="form.remark"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24" v-if="(title=='现金抵扣券'||title=='销售套餐')&&cashData.length>0">
        <el-col :span="24">
          <el-form-item label="" :label-width="formLabelWidth" >
            <el-alert title=" 正在使用的现金券 " type="warning" :closable="false"></el-alert>
            <el-table
              :data="cashData"
              size="mini"
              stripe
              border
              style="width: 100%;">
              <el-table-column
                width="50"
                label="序号"
                align="center" >
                <template slot-scope="scope">
                  {{1+scope.$index}}
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                label="时间" width="140" >
                <template slot-scope="scope">
                  {{(scope.row.adddate || "").substr(0, 19)}}
                </template>
              </el-table-column>
              <el-table-column
                label="购买额" prop="money"
                align="right"
                header-align="center"
                width="90" >
                <template slot-scope="scope">
                  {{(scope.row.money-scope.row.givemoney) | numeric(2)}}
                </template>
              </el-table-column>
              <el-table-column
                label="赠送额" prop="givemoney"
                align="right"
                header-align="center"
                width="90" >
                <template slot-scope="scope">
                  {{scope.row.givemoney | numeric(2)}}
                </template>
              </el-table-column>
              <el-table-column
                prop="handleovermoney"
                label="余额"
                align="right"
                header-align="center"
                width="90">
                <template slot-scope="scope">
                  {{(scope.row.money-scope.row.handleovermoney) | numeric(2)}}
                </template>
              </el-table-column>
              <el-table-column
                prop="title"
                label="内容" :show-overflow-tooltip="true"
                align="left"
                width="240">
              </el-table-column>
            </el-table>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="saveData" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
</template>


<script>
  import {saveData,listCash} from '@/api/set/machinecoupon';
  import {couponLogSave} from '@/api/set/givecouponlog';
  import {getListData} from '@/api/set/externaldept';

  export default {
    name: "DataContactEdit",
    data() {
      return {
        data2: [],
        value4: [1],
        loading: false,//提交时显示加载中，防止多提交
        dialogFormVisible: false,
        formLabelWidth: '120px',
        cashData:[],
        form: {//表单属性
          customername: '',
          count: '',
          customerserial: '',
          customerserials: '',
          favourunitguid: '',
          hasuse: 0,
          paytype:'',
          remark:'',
          begindate: '',
          enddate: '',
        },
        storeInfo: {
          coupon: '',
          province: '',
          city: '',
          county: '',
          independentserial: ''
        },//优惠券的地址和独立核算部门
        tableData: [],
        title: '',//券的名称
        searchdatevalue: [],//时间段选择
      }
    },
    methods: {
      show() {
        this.dialogFormVisible = true;
      },
      initForm(unitguid, storeInfo, title) {
        this.title = title
        this.value4 = [1]
        this.form.paytype='';
        this.form.remark='';
        this.form.count=1;
        this.loading = false
        this.form.customerserials = '';
        this.form.customerserial = '';
        this.form.customername = '';
        this.form.favourunitguid = unitguid
        this.storeInfo.coupon = storeInfo.coupon
        this.storeInfo.province = storeInfo.province
        this.storeInfo.city = storeInfo.city
        this.storeInfo.county = storeInfo.county
        this.storeInfo.independentserial = storeInfo.independentserial
        this.searchdatevalue = []
        this.form.hasuse = 0
        this.cashData=[]
      },
      selExternal() {
        this.$refs.externalsel.show()
      },
      clearCustomerName() {
        this.form.customerserials = '';
        this.form.customername = '';
        this.cashData=[]
      },
      selectExternalDept(customerserial, deptname, row) {
        this.form.customerserials = customerserial;
        this.form.customername = deptname;

        listCash({
          customerserial: customerserial,
          type: 3
        }).then(response => {
          this.cashData = response.data.obj;
        })
      },
      handleChange(value) {
        this.form.count = value
      },
      //赠送门店优惠券
      saveData() {
        if (this.form.customername == null || this.form.customername == '' || this.form.customerserials == null ||
          this.form.customerserials == '') {
          this.$message.error('客户必须选择！');
          return;
        }
        if(this.title=='加工券'||this.title=='现金抵扣券'||this.title=='销售套餐'){
          if(!this.form.paytype){
            this.$message.error('购买方式必选！');
            return;
          }
          if(this.form.paytype=='z'&&!this.form.remark){
            this.$message.error('备注必填！');
            return;
          }
        }
        this.loading = true;
        this.form.begindate = this.searchdatevalue && this.searchdatevalue.length > 0 ? this.searchdatevalue[0] : ""
        this.form.enddate = this.searchdatevalue && this.searchdatevalue.length > 0 ? this.searchdatevalue[1] : ""
        saveData(this.form).then(response => {
          if (response.data.code === 0) {
            this.$message({
              message: '保存成功',
              type: 'success'
            })
            this.couponLogSave();
            this.dialogFormVisible = false;
            //成功后刷新优惠券列表
            this.$emit('bindGrid');
          } else {
            this.$message.error(response.data.msg);
            this.loading = false;
          }
        });
      },
      //优惠券赠送日志
      couponLogSave() {
        couponLogSave({
          totalnumber: this.form.count,//赠送数量
          favourunitguid: this.form.favourunitguid,//优惠策略unitguid
          customerserial: this.form.customerserial,//客户编码
          customername: this.form.customername,//客户
        }).then(response => {

        })
      }
    },
    mounted() {
    },
    components: {}
  }
</script>
<style>
  .specialtransfer .el-transfer-panel {
    width: 350px;
  }

  .specialtransfer .el-transfer-panel__body {
    height: 546px;
  }

  .specialtransfer .el-transfer-panel__list.is-filterable {
    height: 250px;
    padding-top: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/set/salefavour/MachinecouponDialog.vue